import api from '../../../../../configurations/service';
import * as types from './mutation-types';
import { orderTypeEnum } from '../../Shared/enums/orderTypeEnum';

export const setProductCollection = async (context, params) => {
  const body = {
    search: params?.search ?? '',
    maxResults: params?.results ?? 30,
    orderType: params?.orderType ?? orderTypeEnum.SALE,
  };
  const { data } = await api(2).post('inventory.search-products-for-documents', body);
  const products = Array.isArray(data.data) ? data.data : [];
  context.commit(types.SET_PRODUCT_COLLECTION, products);
};

export const resetProductCollection = (context) => {
  context.commit(types.SET_PRODUCT_COLLECTION, []);
};

export const setProductInventory = async (context, id) => {
  const body = {
    id,
  };
  const { data } = await api().post('inventory.get-product', body);
  const [product] = data;
  delete product.fiscal.produto.id;
  context.commit(types.SET_PRODUCT_INVENTORY, product);
};
